<!-- Page 1 -->
<div class="pdf-page app-aul-021-24" id="aul02124">
  <!-- <app-policy-header></app-policy-header>-->
  <div>
    <p class="font-large mb-0" style="text-align: center">
      <b>PROPERTY ENHANCEMENT COVERAGE</b>
    </p>
    <p class="font-large" style="text-align: center">
      <b>ENDORSEMENT - GOLD</b>
    </p>
    <p class="font-large">
      <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ IT CAREFULLY</b>
    </p>
    <p class="font-small">
      In consideration of the premium charged, it is understood and agreed that
      this policy is amended to include the below coverages subject to the
      limits of insurance and deductibles shown.
    </p>
    <p class="font-small">
      Summary of Coverages and the policy coverage forms referenced herein form
      this endorsement and are a part of the policy. Unless otherwise noted
      these Limits of Insurance apply per occurrence.
    </p>
    <p class="font-small">
      <b>
        This endorsement does not increase the total limits of liability as
        shown in the policy Declarations.
      </b>
    </p>
    <p class="font-small">
      <b
        ><span style="text-decoration: underline"
          >SUMMARY OF COVERAGE EXTENSIONS</span
        ></b
      >
    </p>
    <table class="font-small" style="font-weight: bold; width: 100%">
      <tbody>
        <tr>
          <td style="width: 25%">Coverage</td>
          <td style="width: 25%">Limit of Insurance</td>
          <td style="width: 25%">Deductible (per occurrence)</td>
        </tr>
        <tr>
          <td>1. Accounts Receivable</td>
          <td>$40,000</td>
          <td>$1,000</td>
        </tr>
        <tr>
          <td>2. Employee Dishonesty</td>
          <td>$40,000 aggregate</td>
          <td>$1,000</td>
        </tr>
        <tr>
          <td>3. Monies & Securities</td>
          <td>$40,000 aggregate</td>
          <td>$1,000</td>
        </tr>
        <tr>
          <td>4(A). Outdoor Property <br />(Trees, Shrubs or Plants)</td>
          <td>$4,000 aggregate</td>
          <td>$500</td>
        </tr>
        <tr>
          <td>
            4(B). Outdoor Property <br />
            (Fence, Radio, TV, Antennas, Sign Only)
          </td>
          <td>$50,000</td>
          <td>$1,000</td>
        </tr>
        <tr>
          <td>5. Personal Effects and Property of Others</td>
          <td>$40,000 aggregate</td>
          <td>$1,000</td>
        </tr>
        <tr>
          <td>6. Property in Transit</td>
          <td>$40,000</td>
          <td>$1,000</td>
        </tr>
        <tr>
          <td>7. Property Off-Premises</td>
          <td>$40,000</td>
          <td>$1,000</td>
        </tr>
        <tr>
          <td>8. Spoilage</td>
          <td>$40,000</td>
          <td>$1,000</td>
        </tr>
        <tr>
          <td>
            9. Valuable Papers and Records <br />
            (Other than Electronic Data)
          </td>
          <td>$40,000</td>
          <td>$1,000</td>
        </tr>
        <tr>
          <td>10. Electronic Data Property</td>
          <td>$40,000</td>
          <td>$1,000</td>
        </tr>
        <tr>
          <td>11. Backup of Sewers and Drains</td>
          <td>$20,000</td>
          <td>$1,000</td>
        </tr>
        <tr>
          <td>12. Building Glass – Tenant’s Policy</td>
          <td>$20,000</td>
          <td>$1,000</td>
        </tr>
        <tr>
          <td>13. Fire Department Service Charges</td>
          <td>$10,000</td>
          <td>$0</td>
        </tr>
      </tbody>
    </table>
    <br />
    <div class="font-small">
      <p><b>The coverage provided by this endorsement;</b></p>
      <p>
        1. Applies to the Covered Premises described in the Commercial Property
        Supplemental Declarations, “Declarations”;
      </p>

      <p>2. Is not subject to coinsurance; and</p>
      <p>
        3. Ends on the Policy expiration date shown on the Common Policy
        Declarations; and
      </p>
      <p>
        4. We will not pay for loss resulting directly from an "occurrence"
        under each Coverage Extension unless the amount of loss exceeds the
        Deductible applicable and shown above. We will then pay the amount of
        loss in excess of the Deductible, up to the Limit of Insurance.
      </p>
      <p>
        <b>
          If Windstorm and Hail are excluded perils under this policy, as
          detailed within the declaration and schedule, all coverages within
          this endorsement will also exclude Windstorm and Hail perils.
        </b>
      </p>
    </div>
  </div>
</div>

<!-- Page 2 -->
<div class="font-small pdf-page app-aul-021-24">
  <ol>
    <!-- 1 -->
    <li>
      <b>Accounts Receivable</b><br />
      <ol type="a">
        <!-- a -->
        <li>
          If this policy covers Your Business Personal Property, this Coverage
          Extension extends that insurance to apply to accounts receivable. We
          will pay:
          <ul style="list-style-type: none">
            <li>
              (1) All amounts due from your customers that you are unable to
              collect;
            </li>
            <li>
              (2) Interest charges on any loan required to offset amounts you
              are unable to collect pending our payment of these amounts;
            </li>
            <li>
              (3) Collection expenses in excess of your normal collection
              expenses that are made necessary by loss or damage; and
            </li>
            <li>
              (4) Other reasonable expenses that you incur to reestablish your
              records of accounts receivable; that result from direct physical
              loss or damage by any Covered Causes of Loss to your records of
              accounts receivable.
            </li>
          </ul>
        </li>
        <!-- b -->
        <li>
          Coverage does not apply to:
          <ul style="list-style-type: none">
            <li>
              (1) Records of accounts receivable in storage away from the
              Covered Premises; or
            </li>
            <li>
              (2) Contraband, or property in the course of illegal
              transportation or trade.
            </li>
          </ul>
        </li>
        <!-- c -->
        <li>
          If you give us written notice within 10 days of removal of your
          records of accounts receivable because of imminent danger of loss or
          damage, we will pay for loss or damage while they are:
          <ul style="list-style-type: none">
            <li>
              (1) At a safe place away from the Covered Premises; (2) Being
              taken to and returned from that place.
            </li>
          </ul>
        </li>
        <!-- d -->
        <li>
          The most we will pay under this Coverage Extension for loss or damage
          is $40,000 any one occurrence. This Limit does not increase the total
          Limit of Insurance as shown in the policy Declarations.
        </li>
        <!-- e -->
        <li>
          Section B. Exclusions of the CAUSES OF LOSS – SPECIAL FORM does not
          apply to this Accounts Receivable Extension, except for:
          <ul style="list-style-type: none">
            <li>(1) Paragraph B.1.b., Earth Movement</li>
            <li>(2) Paragraph B.1.c., Governmental Action</li>
            <li>(3) Paragraph B.1.d., Nuclear Hazard;</li>
            <li>(3) Paragraph B.1.f., War and Military Action;</li>
            <li>(4) Paragraph B.1.g., Water;</li>
            <li>
              (5) Paragraph B.2.h. which is deleted and replaced by the
              following:
              <ul style="list-style-type: none">
                <li>
                  h. Dishonest or criminal act by you, anyone else with an
                  interest in the property, any of your or their partners,
                  “members”, officers, “managers”, “employees” (including leased
                  or temporary “employees”), directors, trustees, authorized
                  representatives or anyone to whom you entrust the property for
                  any purpose:
                  <ul style="list-style-type: none">
                    <li>(1) Acting alone or in collusion with others; or</li>
                    <li>
                      (2) Whether or not occurring during the hours of
                      employment.
                    </li>
                  </ul>
                  This exclusion does not apply to acts of destruction by your
                  employees” (including leased or temporary “employees”); but
                  theft by “employees” (including leased or temporary
                  “employees”) or authorized representatives is not covered;
                </li>
              </ul>
            </li>
            <li>(6) Paragraph B.3; and</li>
            <li>
              (7) The following additional exclusions are added and apply to
              this Accounts Receivable<br />Extension:
              <b>We will not pay for any:</b>
              <ul style="list-style-type: none">
                <li>
                  (a) Loss or damage caused by or resulting from alteration,
                  falsification, concealment or destruction of records of
                  Accounts receivable done to conceal the wrongful giving,
                  taking or withholding of “money”, securities” or other
                  property. This exclusion applies only to the extent of the
                  wrongful giving, taking or withholding.
                </li>
                <li>
                  (b) Loss or damage caused by or resulting from bookkeeping,
                  accounting or billing errors or omissions.
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ol>
    </li>
  </ol>
</div>

<!-- Page 3 -->
<div class="font-small pdf-page app-aul-021-24">
  <ul style="list-style-type: none">
    <li>
      <ul style="list-style-type: none">
        <!-- e -->
        <li>
          <ul style="list-style-type: none">
            <li>
              <ul style="list-style-type: none">
                <li>
                  (c) Loss or damage that requires any audit of records or any
                  inventory computation to prove its factual existence.
                </li>
                <li>
                  (d) Loss or damage caused by or resulting from electrical or
                  magnetic injury, disturbance or erasure of electronic
                  recordings that is caused by or results from:
                  <ol type="i">
                    <li>Programming errors or faulty machine instructions;</li>
                    <li>
                      Faulty installation or maintenance of data processing
                      equipment or component parts;
                    </li>
                    <li>
                      An occurrence that took place more than 100 feet from the
                      Covered Premises; or
                    </li>
                    <li>
                      Interruption of electrical power supply, power surge,
                      blackout or brownout if the cause of such occurrence took
                      place more than 100 feet from the Covered Premises.
                      <p>
                        But we will pay for direct loss or damage caused by
                        lightning.
                      </p>
                    </li>
                  </ol>
                </li>
                <li>
                  (e) Loss or damage caused by or resulting from voluntary
                  parting with any property by you or anyone else to whom you
                  have entrusted the property if induced to do so by any
                  fraudulent scheme, trick, device or false pretense.
                </li>
                <li>
                  (f) Loss or damage caused by or resulting from unauthorized
                  instructions to transfer property to any person or to any
                  place.
                </li>
                <li>
                  (g) Delay, loss of use, loss of market or any other
                  consequential loss.
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
  <ol start="2">
    <!-- 2 -->
    <li>
      <b>Employee Dishonesty</b>
      <ol type="a">
        <li>
          We will pay for direct loss of or damage to Business Personal Property
          and “money” and “securities resulting from dishonest acts committed by
          any of your “employees” acting alone or in collusion with other
          persons (except you or your partner) with the manifest intent to:
          <ul style="list-style-type: none">
            <li>(1) Cause you to sustain loss or damage: and also</li>
            <li>
              (2) Obtain financial benefit (other than salaries, commissions,
              fees bonuses, promotions, awards, profit sharing, pensions or
              other employee benefits earned in the normal course of employment)
              for:
              <ol type="i">
                <li>Any “employee”, or</li>
                <li>Any other person or organization</li>
              </ol>
            </li>
          </ul>
        </li>
        <li>
          We will not pay for loss or damage:
          <ul style="list-style-type: none">
            <li>
              (1) Resulting from any dishonest or criminal act that you, any of
              your partners, or any of your “members” or trustees commit whether
              acting alone or in collusion with other persons.
            </li>
            <li>
              (2) Resulting from any dishonest act committed by any of your
              “employees” (except as provided in Paragraph a.), “managers”,
              authorized representatives, officers or directors:
              <ul style="list-style-type: none">
                <li>
                  (a) Whether acting alone or in collusion with other persons;
                  or
                </li>
                <li>(b) While performing services for you or otherwise</li>
              </ul>
            </li>
            <li class="mt-5">
              (3) The only proof of which as to its existence or amount is:
              <ul style="list-style-type: none">
                <li>(a) An inventory computation; or</li>
                <li>(b) A profit and loss computation.</li>
              </ul>
              However, where you establish wholly apart from such computations
              that you have sustained a loss, then you may offer your inventory
              records and actual physical count of inventory in support of loss
              claimed.
            </li>
          </ul>
        </li>
      </ol>
    </li>
  </ol>
</div>

<!-- Page 4 -->
<div class="font-small pdf-page app-aul-021-24">
  <ul style="list-style-type: none">
    <!-- 2 -->
    <li>
      <ul style="list-style-type: none">
        <li>
          <ul style="list-style-type: none">
            <li>
              (4) Caused by an “employee” if the “employee” had also committed
              theft or any other dishonest act prior to the effective date of
              this policy and you or any of your partners, “members”,
              “managers”, officers, directors or trustees, not in collusion with
              the “employee”, learned of that theft or dishonest act prior to
              the policy period shown in the Declarations.
            </li>
            <li>
              (5) Resulting from an “employee” of yours or predecessor in
              interest of yours, for whom similar prior insurance has been
              cancelled and not reinstated since the last such cancellation.
            </li>
            <li>
              (6) Resulting from trading, whether in your name or in a genuine
              or fictitious account.
            </li>
            <li>
              (7) Resulting from fraudulent or dishonest signing, issuing,
              cancelling or failing to cancel, a warehouse receipt or any papers
              connected with it.
            </li>
            <li>
              (8) resulting from:
              <ul style="list-style-type: none">
                <li>
                  (a) The unauthorized disclosure of your confidential
                  information including, but not limited to, patents, trade
                  secrets, processing methods or customer lists; or
                </li>
                <li>
                  (b) The unauthorized use or disclosure of confidential
                  information of another person or entity which is held by you
                  including, but not limited to, financial information, personal
                  information, credit card information or similar non-public
                  information.
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
      <ol type="a" start="3">
        <li class="mt-5">
          All loss or damage caused by one or more persons; or involving a
          single act or series of related acts; is considered one “occurrence”.
        </li>
        <li>
          The most we will pay, under this Employee Dishonesty Coverage
          Extension, for loss or damage regardless of the number of claims or
          occurrences is $40,000 in the aggregate during this policy period.
          This Limit does not increase the total Limit of Insurance as shown in
          the policy Declarations.
        </li>
        <li>
          We will pay only for loss or damage you sustain through acts committed
          or events occurring during the policy period shown in the Declarations
          regardless of the number of years this policy remains in force or the
          number of premiums paid, no Limit of Insurance cumulates from year to
          year or period to period.
        </li>
        <li>
          This Employee Dishonesty Coverage Extension does not apply to any
          “employee” immediately upon discovery by You; or Any of your partners,
          “members”, “managers”, officers or directors not in collusion with the
          “employee”; of any dishonest act committed by that “employee” before
          or after being hired by you.
        </li>
        <li>
          We will pay only for covered loss or damage sustained during the
          policy period shown in the Declarations and discovered no later than
          60 days from the end of the policy period shown in the Declarations or
          any cancellation endorsements.
        </li>
        <li>
          If you (or any predecessor in interest) sustained loss or damage
          during the period of any prior insurance that you could have recovered
          under that insurance except that the time within which to discover
          loss or damage had expired, we will pay for it under this Employee
          Dishonesty Coverage, provided:
          <ul style="list-style-type: none">
            <li>
              (1) This Employee Dishonesty Coverage became effective at the time
              of cancellation or termination of the prior insurance; and
            </li>
            <li>
              (2) The loss or damage would have been covered by this Employee
              Dishonesty Coverage Extension had it been in effect when the acts
              or events causing the loss or damage were committed or occurred.
            </li>
          </ul>
        </li>
        <li>
          The insurance under Paragraph (h) above is part of, not in addition
          to, the Limit of Insurance applying to this Employee Dishonesty
          Coverage Extension and is limited to the lesser of the amount
          recoverable under this Coverage Extension or the prior insurance had
          it remained in effect.
        </li>
      </ol>
    </li>
  </ul>
</div>

<!-- Page 5 -->
<div class="font-small pdf-page app-aul-021-24">
  <ol start="3">
    <!-- 3 -->
    <li>
      <b>Money and Securities</b>
      <ol type="a">
        <li>
          We will pay for loss of “money” and “securities” used in your business
          while at a bank or savings institution, at the Covered Premises or in
          transit between any of these places, resulting directly from:
          <ul style="list-style-type: none">
            <li>(1) “Theft”;</li>
            <li>(2) Disappearance; or</li>
            <li>(3) Destruction.</li>
          </ul>
        </li>
        <li>
          In addition to the Limitations and Exclusions applicable to property
          coverage, we will not pay for loss:
          <ul style="list-style-type: none">
            <li>
              (1) Resulting from accounting or arithmetical errors or omissions;
            </li>
            <li>
              (2) Due to the giving or surrendering of property in any exchange
              or purchase; or
            </li>
            <li>
              (3) Of property contained in any money-operated device unless the
              amount of “money” deposited in it is recorded by a continuous
              recording instrument in the device.
            </li>
            <li>
              (4) Caused by or resulting from voluntary parting with any
              property by you or anyone else to whom you have entrusted the
              property if induced to do so by any fraudulent scheme, trick,
              device or false pretense; or
            </li>
            <li>
              (5) Caused by or resulting from unauthorized instructions to
              transfer property to any person or to any place.
            </li>
          </ul>
        </li>
        <li>
          All loss:
          <ul style="list-style-type: none">
            <li>(1) Caused by one or more persons; or</li>
            <li>
              (2) Involving a single act or series of related acts; is
              considered one occurrence.
            </li>
          </ul>
        </li>
        <li>
          The most we will pay under this Money and Securities Coverage
          Extension for loss or damage regardless of the number of claims or
          occurrences is $40,000 in the aggregate during the policy period. This
          Limit does not increase the total Limit of Insurance as shown in the
          policy Declarations.
        </li>
        <li>
          You must keep records of all “money” and “securities” so we can verify
          the amount of any loss or damage.
        </li>
      </ol>
    </li>
    <!-- 4 -->
    <li>
      <b>Outdoor Property</b>
      <ol type="a">
        <li>
          You have chosen to extend the insurance provided by the Coverage Form
          attaching to your policy to apply to your outdoor fences, radio and
          television antennas (including satellite dishes), signs, trees, shrubs
          and plants (other than “stock” of trees, shrubs or plants, or trees,
          shrubs or plants which are part of a vegetated roof), including debris
          removal expense, caused by or resulting from any of the following
          causes of loss if they are Covered Causes of Loss:
          <ul style="list-style-type: none">
            <li>
              (A) For trees, shrubs, or plants:
              <ul style="list-style-type: none">
                <li>(a) Fire;</li>
                <li>(b) Lightning;</li>
                <li>(c) Explosion;</li>
                <li>(d) Riot or Civil Commotion; or</li>
                <li>(e) Aircraft;</li>
              </ul>
            </li>
          </ul>
          The most we will pay for loss or damage for the property listed above
          under this Coverage Extension is $4,000 in the aggregate for all
          losses during this policy period, but not more than $250 for any one
          tree, shrub or plant; and
          <ul style="list-style-type: none">
            <li>
              (B) For outdoor fences; radio and television antennas (including
              satellite dishes), and signs:
              <ul style="list-style-type: none">
                <li>(a) Fire;</li>
                <li>(b) Lightning;</li>
              </ul>
            </li>
          </ul>
        </li>
      </ol>
    </li>
  </ol>
</div>

<!-- Page 6 -->
<div class="font-small pdf-page app-aul-021-24">
  <ul style="list-style-type: none">
    <li>
      <ul style="list-style-type: none">
        <li>
          <ul style="list-style-type: none">
            <li>
              <ul style="list-style-type: none">
                <li>(c) Explosion;</li>
                <li>(d) Riot or Civil Commotion;</li>
                <li>(e) Aircraft;</li>
                <li>(f) Windstorm;</li>
                <li>(g) Hail;</li>
                <li>(h) Smoke;</li>
                <li>(i) Vehicles;</li>
                <li>(j) Vandalism;</li>
                <li>(k) Breakage of glass;</li>
                <li>(l) Falling objects;</li>
                <li>(m) Weight of snow, ice or sleet;</li>
                <li>(n) Water damage; or</li>
                <li>
                  (o) Collapse resulting from use of defective materials or
                  methods in construction, remodeling or renovation if the
                  collapse occurs during the course of construction, remodeling
                  or renovation.
                </li>
              </ul>
            </li>
          </ul>
          The most we will pay for loss or damage for the property listed above
          under this Coverage Extension is $50,000, any one occurrence,
          regardless of the types or number of items lost or damaged in that
          occurrence.
        </li>
        <li>
          b. These Limits do not increase the total Limit of Insurance as shown
          in the policy Declarations.
        </li>
        <li>
          c. We will not pay for the expense of removing from the Covered
          Premises the debris of trees, shrubs and plants which are the property
          of others.
        </li>
      </ul>
    </li>
  </ul>
  <ol start="5">
    <!-- 5 -->
    <li>
      <b>Personal Effects and Property of Others</b>
      <ol type="a">
        <li>
          If this policy covers Your Business Personal Property, this Coverage
          Extension extends that insurance to apply to Personal Effects and
          Property of Others. You have chosen to extend the insurance provided
          by this Coverage Part and as defined and described in Section 5.
          Coverage Extensions of the BUILDING AND PERSONAL PROPERTY COVERAGE
          FORM, Paragraph b. Personal Effects and Property of Others.
        </li>
        <li>
          Items (1) and (2) of Paragraph b. Personal Effects and Property of
          Others is deleted and replaced by the following:
          <ul style="list-style-type: none">
            <li>
              (1) Personal effects owned by you, your officers, your partners or
              “members”, your “managers” or your “employees”. This extension
              does not apply to loss or damage by theft.
            </li>
            <li>
              (2) Personal property of others in your care, custody or control.
            </li>
          </ul>
        </li>
        <li>
          The most we will pay for loss or damage under this Coverage Extension
          is $5,000 at the Covered Premises described in the Declarations, but
          not more than $1,000 for any one item of property and not more than
          $40,000 in the aggregate for all losses during this policy period.
          This Limit does not increase the total Limit of Insurance as shown in
          the policy Declarations.
        </li>
      </ol>
      <p>
        Our payment for loss of or damage to personal property of others will
        only be for the account of the owner of the property.
      </p>
    </li>
  </ol>
</div>

<!-- Page 7 -->
<div class="font-small pdf-page app-aul-021-24">
  <ol start="6">
    <!-- 6 -->
    <li>
      <b>Property in Transit</b>
      <ol type="a">
        <li>
          If this policy covers Your Business Personal Property, this Coverage
          Extension extends that insurance to apply to Property In Transit. You
          have chosen to extend the insurance provided by this Coverage Part and
          as defined and described in Section F. Additional Coverage Extensions
          of the CAUSES OF LOSS – SPECIAL FORM, Paragraph 1. Property In
          Transit.
        </li>
        <li>
          Paragraph c. of 1. Property in Transit of Section F. Additional
          Coverage Extensions of the CAUSES OF LOSS – SPECIAL FORM is deleted
          and replaced with the following:
          <ul style="list-style-type: none">
            <li>
              c. The most we will pay under this Coverage Extension for loss or
              damage is $40,000 any one occurrence. This Limit does not increase
              the total Limit of Insurance as shown in the policy Declarations.
            </li>
          </ul>
        </li>
      </ol>
    </li>
    <!-- 7 -->
    <li>
      <b>Property Off-Premises</b>
      <ol type="a">
        <li>
          If this policy covers Your Business Personal Property, this Coverage
          Extension extends that insurance to apply to Property Off-Premises.
          You have chosen to extend the insurance provided by this Coverage Part
          and as defined and described in Section 5. Coverage Extensions of the
          BUILDING AND PERSONAL PROPERTY COVERAGE FORM, Paragraph d. Property
          Off-Premises
        </li>
        <li>
          Item (3) of Paragraph d. Property Off-Premises is deleted and replaced
          by the following:
          <ul style="list-style-type: none">
            <li>
              (3) The most we will pay under this Coverage Extension for loss or
              damage is $40,000 any one occurrence. This Limit does not increase
              the total Limit of Insurance as shown in the policy Declarations.
            </li>
          </ul>
        </li>
      </ol>
    </li>
    <!-- 8 -->
    <li>
      <b>Spoilage</b>
      <ol type="a">
        <li>
          If this policy covers Your Business Personal Property, this Coverage
          Extension extends that insurance to apply to “perishable stock” at the
          Covered Premises described in the Declarations, owned by you or by
          others that is in your care, custody and control but only for the
          following Covered Causes of loss:
          <ul style="list-style-type: none">
            <li>
              (1) Breakdown or Contamination, meaning:
              <ul style="list-style-type: none">
                <li>
                  (a) Change in temperature or humidity resulting from
                  mechanical breakdown or failure of refrigerating, cooling or
                  humidity control apparatus or equipment, only while such
                  equipment or apparatus is at the Covered Premises; and
                </li>
                <li>(b) Contamination by the refrigerant.</li>
              </ul>
            </li>
            <li>
              (2) Power Outage, meaning change in temperature or humidity
              resulting from complete or partial interruption of electrical
              power, either on or off the Covered Premises, due to conditions
              beyond your control.
            </li>
          </ul>
          <p>
            The above Causes of Loss listed under (1) and (2) above apply only
            to this Spoilage Coverage Extension.
          </p>
        </li>
      </ol>
    </li>
  </ol>
</div>

<!-- Page 8 -->
<div class="font-small pdf-page app-aul-021-24">
  <ul style="list-style-type: none">
    <!-- 8a -->
    <li>
      <ol type="a" start="2">
        <li>
          Section B. Exclusions of the CAUSES OF LOSS - SPECIAL FORM does not
          apply to this Spoilage Coverage Extension, except for:
          <ul style="list-style-type: none">
            <li>(1) Paragraph B.1.b. Earth Movement;</li>
            <li>(2) Paragraph B.1.c. Governmental Action;</li>
            <li>(3) Paragraph B.1.d. Nuclear Hazard;</li>
            <li>(4) Paragraph B.1.f. War and Military Action; and</li>
            <li>(5) Paragraph B.1.g. Water</li>
          </ul>
        </li>
        <li>
          The following additional exclusions are added and apply to this
          Spoilage Coverage Extension:
          <ul style="list-style-type: none">
            <li>
              We will not pay for loss or damage caused by or resulting from:
              <ul style="list-style-type: none">
                <li>
                  (1) The disconnection of any refrigerating, cooling or
                  humidity control system from the source of power.
                </li>
                <li>
                  (2) The deactivation of electrical power caused by the
                  manipulation of any switch or other device used to control the
                  flow of electrical power or current.
                </li>
                <li>
                  (3) The inability of an Electrical Utility Company or other
                  power source to provide sufficient power due to:
                  <ul style="list-style-type: none">
                    <li>(a) Lack of fuel; or</li>
                    <li>(b) Governmental order.</li>
                  </ul>
                </li>
                <li>
                  (4) The inability of a power source at the Covered Premises to
                  provide sufficient power due to lack of generating capacity to
                  meet demand.
                </li>
                <li>
                  (5) Breaking of any glass that is a permanent part of any
                  refrigerating cooling or humidity control unit.
                </li>
                <li>
                  (6) Property located:
                  <ul style="list-style-type: none">
                    <li>(1) On buildings;</li>
                    <li>(2) In the open; or</li>
                    <li>(3) In vehicles.</li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li>
          The most we will pay for loss or damage under this Coverage Extension
          is $40,000 any one occurrence, at the Covered Premises described in
          the Declarations. This Limit does not increase the total Limit of
          Insurance as shown in the policy Declarations.
        </li>
        <li>
          You must maintain a refrigeration maintenance or service agreement. If
          you terminate this agreement or for any reason the maintenance or
          service agreement is no longer in force, and do not notify us, the
          insurance provided by this Coverage Extension will be automatically
          suspended at the applicable Covered Premises.
        </li>
      </ol>
    </li>
  </ul>
</div>

<!-- Page 9 -->
<div class="font-small pdf-page app-aul-021-24">
  <ol start="9">
    <!-- 9 -->
    <li>
      <b>Valuable Papers and Records (Other than Electronic Data)</b>
      <ol type="a">
        <li>
          If this policy covers Your Business Personal Property, this Coverage
          Extension extends that insurance to apply to Valuable Papers and
          Records (Other Than Electronic Data). You have chosen to extend the
          insurance provided by this Coverage Part and as defined and described
          in Section 5. Coverage Extensions of the BUILDING AND PERSONAL
          PROPERTY COVERAGE FORM, Paragraph c. Valuable Papers and Records
          (Other Than Electronic Data)
        </li>
        <li>
          Item (4) of Paragraph c. Valuable Papers and Records (Other Than
          Electronic Data) is deleted and replaced by the following:
          <ul style="list-style-type: none">
            <li class="mb-2">
              (4) The most we will pay under this Coverage Extension to replace
              or restore the lost information is $40,000 any one occurrence, at
              the Covered Premises described in the Declarations.
            </li>
            <li class="mb-2">
              We will also pay for the cost of blank material for reproducing
              the records (whether or not duplicates exist), and (when there is
              a duplicate) for the cost of labor to transcribe or copy the
              records. The costs of blank material and labor are subject to the
              Limit of Insurance provided by this Coverage Extension.
            </li>
            <li>
              This Limit does not increase the total Limit of Insurance as shown
              in the policy Declarations.
            </li>
          </ul>
        </li>
      </ol>
    </li>
    <!-- 10 -->
    <li>
      <b>Electronic Data</b>
      <ol type="a">
        <li>
          This Coverage Extension extends and changes the coverage provided
          under Section 4. Additional Coverages of the BUILDING AND PERSONAL
          PROPERTY COVERAGE FORM, Paragraph f. Electronic Data
        </li>
        <li>
          Item (3) of Paragraph f. Electronic Data is deleted and replaced with
          the following:
          <ul style="list-style-type: none">
            <li>
              (3) The Covered Causes under this Coverage Extension, Electronic
              Data, is limited to the "specified causes of loss" as defined in
              CAUSES OF LOSS – SPECIAL FORM and Collapse as set forth in that
              form. Subject to the following:
              <ul style="list-style-type: none">
                <li>
                  (a) If the Causes Of Loss form is endorsed to add a Covered
                  Cause of Loss, the additional Covered Cause of Loss does not
                  apply to the coverage provided under this Coverage Extension,
                  Electronic Data.
                </li>
                <li>
                  (b) If the Causes Of Loss form is endorsed to exclude or
                  remove a Covered Cause of Loss, the excluded or removed
                  Covered Cause of Loss is also excluded or removed from the
                  coverage provided under this Coverage Extension, Electronic
                  Data.
                </li>
                <li>
                  (c) We will not pay for loss or damage caused by a virus,
                  harmful code or similar instruction introduced into or enacted
                  on a computer system (including electronic data) or a network
                  to which it is connected, designed to damage or destroy any
                  part of the system or disrupt its normal operation. Such loss
                  or damage is excluded regardless of any other cause or event
                  that contributes concurrently or in any sequence to the loss.
                </li>
                <li>
                  (d) We will not pay for loss or damage caused by or resulting
                  from manipulation of a computer system (including electronic
                  data) by any employee, including a temporary or leased
                  employee, or by an entity retained by you or for you to
                  inspect, design, install, modify, maintain, repair or replace
                  that system. Such loss or damage is excluded regardless of any
                  other cause or event that contributes concurrently or in any
                  sequence to the loss.
                </li>
                <li></li>
                <li></li>
              </ul>
            </li>
          </ul>
        </li>
      </ol>
    </li>
  </ol>
</div>

<!-- Page 10 -->
<div class="font-small pdf-page app-aul-021-24">
  <ul style="list-style-type: none">
    <li>
      <ol type="a" start="3">
        <li>
          Item (4) of Paragraph f. Electronic Data is deleted and replaced with
          the following:
          <ul style="list-style-type: none">
            <li>
              (4) The most we will pay for loss or damage under this Coverage
              Extension is $40,000 any one occurrence, at the Covered Premises
              described in the Declarations. This Limit does not increase the
              total Limit of Insurance as shown in the policy Declarations.
            </li>
          </ul>
        </li>
      </ol>
    </li>
  </ul>
  <ol start="11">
    <!-- 11 -->
    <li>
      <b>Backup of Sewers and Drains</b>
      <ol type="a">
        <li>
          This Coverage Extension extends your insurance to pay for direct
          physical loss or damage to Covered Property at the Covered Premises
          described in the Declarations, caused by or resulting from discharge
          of water or waterborne material from a sewer, drain or sump, provided
          such discharge is not induced by flood or flood related conditions.
        </li>
        <li>
          The following item (3) is deleted from Paragraph (g) Water, from
          Paragraph (B) Exclusions, of CAUSES OF LOSS - SPECIAL FORM;
          <ul style="list-style-type: none">
            <li>
              (3) Water that backs up or overflows or is otherwise discharged
              from a sewer, drain, sump, sump pump or related equipment;
            </li>
          </ul>
        </li>
        <li>
          The aforementioned references to flood include surface water, waves
          (including tidal wave and tsunami), tides, tidal water, and overflow
          or any body of water, including storm surge.
        </li>
        <li>
          For the purpose of this Coverage Extension, the term drain includes a
          roof drain and related fixtures.
        </li>
        <li>
          There is no coverage under this extension if:
          <ul style="list-style-type: none">
            <li>
              (1) The discharge results from your failure to perform routine
              maintenance or repair necessary to keep a sewer, drain, sump, sump
              pump or related equipment free from obstruction and in proper
              working condition.<br />
              This limitation does not apply to sudden mechanical breakdown of a
              sump pump or its related equipment, provided the breakdown is not
              the result of your negligence; or
            </li>
            <li>
              (2) Sump pump failure is caused by or results from failure of
              power.
            </li>
          </ul>
        </li>
        <li>
          We will not pay the cost of repairing or replacing a sewer, drain,
          sump, sump pump or any related parts or equipment.
        </li>
        <li>
          The most we will pay for loss or damage under this Coverage Extension
          is $20,000 any one occurrence, at the Covered Premises described in
          the Declarations. This Limit does not increase the total Limit of
          Insurance as shown in the policy Declarations.
        </li>
      </ol>
    </li>
  </ol>
</div>

<!-- Page 11 -->
<div class="font-small pdf-page app-aul-021-24">
  <ol start="12">
    <!-- 12 -->
    <li>
      <b> Building Glass - Tenant’s Policy</b>
      <ol type="a">
        <li>
          If you are a Tenant of the Covered Property at the Covered Premises
          described in the Declarations, and You have a contractual
          responsibility to insure the building glass, or a contractual
          responsibility to pay for the loss or damage to that property. This
          Coverage Extension extends your insurance to apply to Building Glass.
        </li>
        <li>
          Building Glass means any glass used in the building construction,
          including windows, doors, structural glazing, canopies or roof,
          masonry glass, glass blocks or hardened laminated glass
        </li>
        <li>
          We will pay for direct physical loss of or damage to building glass in
          or on the building(s) at the Covered Premises caused by or resulting
          from breakage of glass, or chemicals accidentally or maliciously
          applied to glass, provided that:
          <ul style="list-style-type: none">
            <li>
              (1). The value of property covered under this extension will be
              determined in accordance with the Valuation Condition applicable
              under this Coverage Form or Policy; or at the amount for which you
              are liable under contract, whichever is less.
            </li>
            <li>
              (2) If required by law, glass is covered at the cost of
              replacement with safety glazing material.
            </li>
          </ul>
        </li>
        <li>
          The most we will pay for loss or damage under this Coverage Extension
          is $20,000 any one occurrence, at the Covered Premises described in
          the Declarations. This Limit does not increase the total Limit of
          Insurance as shown in the policy Declarations.
        </li>
      </ol>
    </li>
    <!-- 13 -->
    <li>
      <b>Fire Department Service Charges</b>
      <ol type="a">
        <li>
          This Coverage Extension increases the Limit of Insurance under Section
          4. Additional Coverages of the BUILDING AND PERSONAL PROPERTY COVERAGE
          FORM, Paragraph c. Fire Department Service Charges.
        </li>
        <li>
          Paragraph c. Fire Department Service Charges. is deleted and replaced
          by the following:
          <ul style="list-style-type: none">
            <li>
              <b>c. Fire Department Service Charge</b><br />
              When the fire department is called to save or protect Covered
              Property from a Covered Cause of Loss, we will pay up to $10,000
              for service at each Covered Premises described in the
              Declarations. Such limit is the most we will pay regardless of the
              number of responding fire departments or fire units, and
              regardless of the number or type of services performed.
            </li>
            <li>
              <br />This Additional Coverage applies to your liability for fire
              department service charges:
              <ul style="list-style-type: none">
                <li>(1) Assumed by contract or agreement prior to loss; or</li>
                <li>(2) Required by local ordinance.</li>
              </ul>
            </li>
            <li><br />No Deductible applies to this Additional Coverage.</li>
          </ul>
        </li>
        <li>
          This Limit does not increase the total Limit of Insurance as shown in
          the policy Declarations.
        </li>
      </ol>
    </li>
  </ol>
</div>
